<wl-faq [faqAccordionViewModel]="faqAccordionViewModel"></wl-faq>
